const LOG_PREFIX = '[gamification-session]'

export function logSessionFetchDiagnostic(
  res: Response,
  bodyText: string
): void {
  const contentType = res.headers.get('content-type') ?? ''
  const trimmed = bodyText.trimStart()
  const looksLikeHtml =
    contentType.includes('text/html') ||
    trimmed.startsWith('<!') ||
    trimmed.startsWith('<html')

  if (!looksLikeHtml) return

  console.error(LOG_PREFIX, 'expected JSON from BFF, got HTML (likely SPA fallback)', {
    status: res.status,
    contentType,
    url: res.url,
    snippet: trimmed.slice(0, 160)
  })
}
